import config from '../common/config';
import localise from '../common/localise';
import { sendFormSubmitSuccess } from '../utils/dataLayer';

const hearingAidsHowLongMap = {
  'Less than 2 years': '0 - 2 Years',
  '3 to 4 years': '3 - 4 Years',
  'More than 5 years': '5+ Years',
};

const ageRangeMap = {
  '18-35': 'Adult',
  '36-49': 'Adult',
  '50-64': 'Adult',
  '65+': 'Senior',
};

const getGAClientId = () => {
  if (typeof window.ga !== 'function') {
    return null;
  }

  let clientId = '';

  window.ga(function () {
    clientId = window.ga.getAll()[0].get('clientId');
  });
  return clientId;
};

export default class marketoAPI {
  static REGISTER = 1;
  static TEST_RESULT = 2;
  static CTA = 3;

  static mapData(
    type,
    user,
    cIScreenerID,
    data,
    utm,
    interestParams,
  ) {
    // 3 types of marketo submissions:

    // 1: registration
    // 2: test result
    // 3: cta

    // map marketo fields

    let mappedData;
    const PrimaryConditionIndication__c =
      user.howManyEars.toLowerCase() === 'one ear'
        ? 'SSD'
        : 'Hearing Loss in Both Ears';

    const HearingAidUseTime__c =
      hearingAidsHowLongMap[user.hearingAidsHowLong] ||
      hearingAidsHowLongMap['Less than 2 years'];

    const PatientAgeSegment__c =
      ageRangeMap[user.ageRange] || ageRangeMap['18-35'];

    const Marketing_Consent__c = () => {
      // Add countries that require marketing consent checkbox
      const { marketingConsent, country } = user;
      const marketingConsentCountries = [
        'Canada',
        'United Kingdom',
        'Ireland',
      ];
      const consentRequired =
        marketingConsentCountries.indexOf(country) > -1;
      if (!consentRequired) {
        return true;
      }
      return marketingConsent;
    };

    switch (parseInt(type, 10)) {
      case marketoAPI.REGISTER:
      default:
        let mobileno = user.Phone;
        let phoneno = '';
        if (user.Phonetype === '1') {
          phoneno = user.Phone;
          mobileno = '';
        }

        let region = localise.getString('appSettings.region');
        if (region === 'CAM') {
          mappedData = {
            // id fields:

            cIScreenerID: cIScreenerID,

            PrimaryConditionIndication__c:
              PrimaryConditionIndication__c,
            HearingAidUseTime__c,
            PatientAgeSegment__c,
            FirstName: user.firstName,
            LastName: user.lastName,
            Email: user.email,
            PostalCode: user.postcode,
            Phone: phoneno,
            MobilePhone: mobileno,
            CountryofResidence__c: user.country,

            Marketing_Consent__c: Marketing_Consent__c()
              ? 'Given'
              : '',
            LeadSource: 'Digital',
            personSourceDetails: 'Webform',
            leadSourceDetails: 'Webform',
            RecordTypeId: '0125g000000Co32AAC',
            uTMSource: utm.source,
            uTMCampaign: utm.campaign,
            uTMContent: utm.content,
            uTMMedium: utm.medium,
            uTMTerm: utm.term,
            cIScreenersequence: 1,
            Marketing_Consent_Email__c: Marketing_Consent__c()
              ? 'Given'
              : '',
            Marketing_Consent_Events__c: Marketing_Consent__c()
              ? 'Given'
              : '',
            Marketing_Consent_Newsletters__c: Marketing_Consent__c()
              ? 'Given'
              : '',
            Marketing_Consent_Product_Info__c: Marketing_Consent__c()
              ? 'Given'
              : '',

            JourneyStage__c: user.bestDescription,
            indicatedConsent:
              user.country !== 'Canada' || user.marketingConsent
                ? 'Given'
                : null,
            interestType: interestParams.type,
            interestSubReason: interestParams.subReason,
            interestCaptureDate: new Date().toISOString(),
            interestIndicatedJourneyStage: user.bestDescription,
            interestSource: 'Digital',
            interestSourceDetails: 'Webform',
            interestProductFamily: interestParams.productFamily,
            interestProduct: interestParams.product,
            googleAnalyticsClientID: getGAClientId(),
            captchaToken: user.reCaptchaToken,
          };
          if (user.country === 'Canada') {
            mappedData.Marketing_Consent_Survey__c =
              Marketing_Consent__c() ? 'Given' : '';
          }
        } else if (region === 'EMEA') {
          mappedData = {
            // id fields:

            cIScreenerID: cIScreenerID,

            PrimaryConditionIndication__c:
              PrimaryConditionIndication__c,
            HearingAidUseTime__c,
            PatientAgeSegment__c,
            FirstName: user.firstName,
            LastName: user.lastName,
            Email: user.email,
            PostalCode: user.postcode,
            CountryofResidence__c: user.country,

            Marketing_Consent__c: Marketing_Consent__c()
              ? 'Given'
              : '',
            Marketing_Consent_Email__c: Marketing_Consent__c()
              ? 'Given'
              : '',
            Marketing_Consent_Survey__c: Marketing_Consent__c()
              ? 'Given'
              : '',
            Preferred_Language__c: 'English',
            LeadSource: 'Digital',
            personSourceDetails: 'Webform',
            leadSourceDetails: 'Webform',
            RecordTypeId: '0125g000000Co32AAC',
            uTMSource: utm.source,
            uTMCampaign: utm.campaign,
            uTMContent: utm.content,
            uTMMedium: utm.medium,
            uTMTerm: utm.term,
            cIScreenersequence: 1,

            JourneyStage__c: user.bestDescription,
            indicatedConsent: user.marketingConsent ? 'Given' : null,
            interestType: interestParams.type,
            interestSubReason: interestParams.subReason,
            interestCaptureDate: new Date().toISOString(),
            interestIndicatedJourneyStage: user.bestDescription,
            interestSource: 'Digital',
            interestSourceDetails: 'Webform',
            interestProductFamily: interestParams.productFamily,
            interestProduct: interestParams.product,
            googleAnalyticsClientID: getGAClientId(),
            captchaToken: user.reCaptchaToken,
          };
        } else {
          mappedData = {
            // id fields:

            cIScreenerID: cIScreenerID,

            PrimaryConditionIndication__c:
              PrimaryConditionIndication__c,
            HearingAidUseTime__c,
            PatientAgeSegment__c,
            FirstName: user.firstName,
            LastName: user.lastName,
            Email: user.email,
            PostalCode: user.postcode,
            Phone: phoneno,
            MobilePhone: mobileno,
            CountryofResidence__c: user.country,

            Marketing_Consent__c: Marketing_Consent__c()
              ? 'Given'
              : '',
            LeadSource: 'Digital',
            personSourceDetails: 'Webform',
            leadSourceDetails: 'Webform',
            RecordTypeId: '0125g000000Co32AAC',
            uTMSource: utm.source,
            uTMCampaign: utm.campaign,
            uTMContent: utm.content,
            uTMMedium: utm.medium,
            uTMTerm: utm.term,
            cIScreenersequence: 1,

            JourneyStage__c: 'Obtaining a diagnosis',
            indicatedConsent: 'Given',
            interestType: interestParams.type,
            interestSubReason: interestParams.subReason,
            interestCaptureDate: new Date().toISOString(),
            interestIndicatedJourneyStage: 'Obtaining a diagnosis',
            interestSource: 'Digital',
            interestSourceDetails: 'Webform',
            interestProductFamily: interestParams.productFamily,
            interestProduct: interestParams.product,
            googleAnalyticsClientID: getGAClientId(),
            captchaToken: user.reCaptchaToken,
          };
        }
        break;

      case marketoAPI.TEST_RESULT:
        // TEST RESULT
        // detailedResults: {candidacy: 3, scorePercentage: 21, testDetails: "<somehtml></somehtml>"}

        mappedData = {
          FirstName: user.firstName,
          LastName: user.lastName,
          Email: user.email,

          HearingAidCheckresults__c: `Class ${data.candidacy}`, // Class 0 through to Class 3
          cIScreenerdetails: data.testDetails,
          cIScreenersequence: 2,
          cIScreenerResult: data.scorePercentage,

          captchaToken: user.reCaptchaToken,
        };
        break;

      case marketoAPI.CTA:
        // CTA

        mappedData = {
          CI_Screener_CTA__c: data.CI_Screener_CTA__c,
          FirstName: user.firstName,
          LastName: user.lastName,
          Email: user.email,
        };
        break;
    }

    return mappedData;
  }

  static sendNonBlocking(
    type,
    user,
    cIScreenerID,
    data,
    utm,
    interestParams,
  ) {
    // marketo forms API does not have an form.onError function
    // if I returned a promise from the function and the call to form.submit is unsuccessful we would wait forever
    // easiest solution is dont wait for response from form.submit
    // if it fails we dont catch it

    const functionName = 'marketoAPI.sendNonBlocking: ';

    // map data to marketo fields

    const mappedData = marketoAPI.mapData(
      type,
      user,
      cIScreenerID,
      data,
      utm,
      interestParams,
    );

    if (
      !mappedData.FirstName ||
      !mappedData.FirstName === '' ||
      !mappedData.LastName ||
      !mappedData.LastName === '' ||
      !mappedData.Email ||
      !mappedData.Email === ''
    ) {
      console.log(functionName + 'missing fields in data');
      return 'invalid data';
    }

    if (!window.MktoForms2) {
      console.log(functionName, 'window.MktoForms2 does not exist');
      return 'window.MktoForms2 does not exist';
    }

    console.log(functionName, 'json to send = ', mappedData);

    const env = config.marketo[config.env];
    let localformID = '';
    const region = localise.getString('appSettings.region');
    switch (region) {
      case 'APAC':
        localformID = env.formIdAPAC;
        break;
      case 'CAM':
        localformID = env.formIdCAM;
        break;
      case 'EMEA':
        localformID = env.formIdEMEA;
        break;
      default:
        localformID = env.formId;
        break;
    }

    window.MktoForms2.loadForm(
      env.url,
      env.munchkinId,
      localformID,
      (form) => {
        form.addHiddenFields(mappedData);

        if (form.submittable()) {
          form
            // Triggers the form’s submit event. This will start the from submit flow, performing validation,
            // firing any onSubmit events, submitting the form, and firing any onSuccess events if form submission was successful.
            .submit()

            // Adds a callback that will be called when the form has been successfully submitted but before the lead is forwarded
            // to the follow up page. Can be used to prevent the lead from being forwarded to the follow up page after successful submission.

            .onSuccess((response) => {
              sendFormSubmitSuccess(type);

              return false; // Cancel the follow up page action
            });
        }
      },
    );

    return true;
  }
}
